<div class="container mt-3">
  <form [formGroup]="statusForm">
    <div class="grid">
      <div class="field col-12">
        <p-floatlabel>
          <p-select inputId="status" class="w-100" [options]="statuses" optionValue="status"
                    formControlName="status" optionLabel="title"></p-select>
          <label [for]="'status'">Status</label>
        </p-floatlabel>
        <span class="text-sm text-black-alpha-50 mt-1">Achtung: Der Status sollte hier nur in Ausnahmefällen gesetzt werden. Besser ist die geplante "Statusänderung" mit Datum weiter unten.</span>

        @if (statusForm.get('status')?.errors?.['required'] && statusForm.get('status')?.dirty) {
          <span class='p-error'>
            Status ist erforderlich.
          </span>
        }
      </div>
    </div>
    @if (statusForm.get('status')?.value === Status.ACTIVE) {
      <div class="mt-2">
        <h5>Nutzernummer</h5>
        <app-customer-no-inputs [codeForm]="$any(this.statusForm.controls['codeForm'])"></app-customer-no-inputs>
      </div>
    }

    <div class="mt-2">
      <h5>Besonderheit Abholung</h5>
      <div class="grid mt-4">
        <div class="field col-12">
          <p-floatlabel variant="in">
            <textarea #collection_remark maxlength="200" id="collection_remark" class="w-100" type="text"
                      formControlName="collection_remark" pTextarea></textarea>
            <label for="collection_remark">Bemerkung</label>
          </p-floatlabel>
          <div class="d-flex w-100 justify-content-end text-muted text-sm">
            {{ collection_remark.textLength }}/200
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2">
      <h5>Besonderheit Ladendienst</h5>
      <div class="grid mt-4">
        <div class="field col-12">
          <p-floatlabel>
            <p-date-picker inputId="shop_remark_valid_until" class="w-100" dateFormat="dd.mm.yy"
                           formControlName="shop_remark_valid_until"></p-date-picker>
            <label [for]="'shop_remark_valid_until'">Gültig bis</label>
          </p-floatlabel>
        </div>
        <div class="field col-12">
          <p-floatlabel variant="in">
            <textarea #shop_remark maxLength="200" id="shop_remark" class="w-100" type="text"
                      formControlName="shop_remark" pTextarea></textarea>
            <label for="shop_remark">Bemerkung</label>
          </p-floatlabel>
          <div class="d-flex w-100 justify-content-end text-muted text-sm">
            {{ shop_remark.textLength }}/200
          </div>
        </div>
        @if (statusForm.get('pickup_id')?.value) {
          <div class="field col-12">
            <p-floatlabel>
              <input id="unpaid_balance" class="w-100" type="text" formControlName="unpaid_balance" pInputText/>
              <label for="unpaid_balance">Offene Restschuld (in €)</label>
            </p-floatlabel>
          </div>
          <input type="hidden" formControlName="pickup_id">
        }
      </div>
    </div>

    <div class="grid mt-2">
      <div class="field col-12">
        <p-floatlabel>
          <p-date-picker inputId="certificate_valid_until" class="w-100" dateFormat="dd.mm.yy"
                         formControlName="certificate_valid_until"></p-date-picker>
          <label [for]="'certificate_valid_until'">Einkommensnachweis gültig bis</label>
        </p-floatlabel>
      </div>
    </div>

    @if (settingsService.settings()?.expirationActivated) {
      <div class="grid mt-2">
        <div class="field col-12">
          <p-floatlabel>
            <p-date-picker inputId="expiration_date" class="w-100" dateFormat="dd.mm.yy"
                           formControlName="expiration_date"></p-date-picker>
            <label [for]="'expiration_date'">Befristungsdatum</label>
          </p-floatlabel>
        </div>
      </div>
    }

    <div class="mt-2">
      <h5>Beratungsgespräch</h5>
      <div class="grid mt-4">
        <div class="field col-12">
          <p-floatlabel>
            <p-date-picker inputId="consultation_date" class="w-100" [showTime]="true" dateFormat="dd.mm.yy"
                           formControlName="consultation_date"></p-date-picker>
            <label [for]="'consultation_date'">Datum des Beratungsgesprächs</label>
          </p-floatlabel>
        </div>
      </div>
    </div>

    <div class="mt-2">
      <h5>Statusänderung</h5>
      <div class="grid mt-4">
        <div class="field col-12 md:col-6">
          <p-floatlabel>
            <p-date-picker inputId="status_change_date" class="w-100" dateFormat="dd.mm.yy" [minDate]="tomorrow"
                           formControlName="status_change_date"></p-date-picker>
            <label [for]="'status_change_date'">Datum</label>
          </p-floatlabel>
        </div>
        <div class="field col-12 md:col-6">
          <p-floatlabel>
            <p-select inputId="status_change_target" class="w-100" [options]="statuses" optionValue="status"
                      formControlName="status_change_target" optionLabel="title"></p-select>
            <label [for]="'status_change_target'">Ziel-Status</label>
          </p-floatlabel>
        </div>
        @if (this.statusForm.get('status_change_target')?.value === Status.DROPPED_OUT) {
          <div class="field col-12">
            <p-floatlabel>
              <p-select inputId="status_change_reason" class="w-100" [options]="statusChangeReasonService.reasons"
                        optionValue="id" formControlName="status_change_reason" optionLabel="title"
              ></p-select>
              <label [for]="'status_change_reason'">Grund</label>
            </p-floatlabel>
          </div>
        }
        <div class="field col-12">
          <p-floatlabel variant="in">
            <textarea id="status_change_comment" class="w-100" type="text" formControlName="status_change_comment"
                      pTextarea></textarea>
            <label for="status_change_comment">Kommentar</label>
          </p-floatlabel>
        </div>
        @if (this.statusForm.get('status_change_target')?.value === Status.ACTIVE) {
          <div class="field col-12">
            <h5>Künftige Nutzernummer</h5>
            <app-customer-no-inputs [codeForm]="$any(statusForm.controls['futureCodeForm'])"
                                    [upcoming]="true"></app-customer-no-inputs>
          </div>
        }
        <div class=" field col-12 flex justify-content-end">
          @if (statusForm.controls['status_change_date'].value || statusForm.controls['status_change_target'].value) {
            <p-button (click)="cancelStatusChange()" [outlined]="true" severity="danger"
                      label="WECHSEL STORNIEREN"></p-button>
          }
        </div>
      </div>
    </div>
  </form>
</div>
